import { all, fork } from "redux-saga/effects";
import { fileDownloadSaga } from "./file-download/file-download-saga";

export function* hooksSaga() {
  yield all([fork(fileDownloadSaga)]);
}
